/**
 * Couleurs des catégories de projets
 */
export const CATEGORIES = {
  FLEET: 'Fleet',
  TMS: 'TMS',
  DIGITAPPRO: 'DigitAppro',
  XMOBILE: 'XMobile',
  NEOS: 'NEOS',
  WMS: 'WMS',
  LEGACY: 'Legacy',
  AUTRE: 'Autre'
};

export const CATEGORY_COLORS = {
  [CATEGORIES.FLEET]: '#079992',
  [CATEGORIES.TMS]: '#00c89b',
  [CATEGORIES.DIGITAPPRO]: '#f59e0b', // jaune
  [CATEGORIES.WMS]: '#8b5cf6', // violet
  [CATEGORIES.NEOS]: '#3b82f6', // bleu
  [CATEGORIES.XMOBILE]: '#06b6d4', // cyan
  [CATEGORIES.LEGACY]: '#94a3b8', // ardoise
  [CATEGORIES.AUTRE]: '#6b7280' // gris
};

/**
 * Retourne la couleur associée à une catégorie
 * @param {string} categorie - Le nom de la catégorie
 * @returns {string} - La couleur hexadécimale
 */
export const getCategoryColor = (categorie) => {
  if (!categorie) return CATEGORY_COLORS[CATEGORIES.AUTRE];
  
  const upperCategorie = categorie.toUpperCase();
  
  if (upperCategorie.includes('FLEET')) {
    return CATEGORY_COLORS[CATEGORIES.FLEET];
  }
  
  if (upperCategorie.includes('TMS')) {
    return CATEGORY_COLORS[CATEGORIES.TMS];
  }
  
  if (upperCategorie.includes('DIGITAPPRO')) {
    return CATEGORY_COLORS[CATEGORIES.DIGITAPPRO];
  }
  
  if (upperCategorie.includes('XMOBILE')) {
    return CATEGORY_COLORS[CATEGORIES.XMOBILE];
  }
  
  if (upperCategorie.includes('NEOS')) {
    return CATEGORY_COLORS[CATEGORIES.NEOS];
  }
  
  if (upperCategorie.includes('WMS')) {
    return CATEGORY_COLORS[CATEGORIES.WMS];
  }
  
  if (upperCategorie.includes('LEGACY')) {
    return CATEGORY_COLORS[CATEGORIES.LEGACY];
  }
  
  return CATEGORY_COLORS[CATEGORIES.AUTRE];
};

/**
 * Retourne une classe CSS pour la couleur de fond d'une catégorie
 * @param {string} categorie - Le nom de la catégorie
 * @returns {string} - Style inline pour la couleur de fond
 */
export const getCategoryBadgeStyle = (categorie) => {
  const color = getCategoryColor(categorie);
  return {
    backgroundColor: color,
    color: 'white'
  };
};

/**
 * Liste des catégories disponibles pour les sélections
 */
export const AVAILABLE_CATEGORIES = [
  { label: 'Fleet', value: 'Fleet' },
  { label: 'TMS', value: 'TMS' },
  { label: 'DigitAppro', value: 'DigitAppro' },
  { label: 'XMobile', value: 'XMobile' },
  { label: 'NEOS', value: 'NEOS' },
  { label: 'Legacy', value: 'Legacy' },
  { label: 'Autre', value: 'Autre' }
]; 